//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    universe: string;
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /website-cms/{universe}/custom-selections-template -> get -> ${code}`);
    };
};

export const Response200IO = t.array(t.interface({
    fields: t.unknown,
    id: t.number,
    is_color: t.boolean,
    is_description: t.boolean,
    is_image: t.boolean,
    is_rating: t.boolean,
    label: t.string,
    slug: t.string,
    universe: t.string,
}));
export type Response200Type = Array<{
    fields: unknown;
    id: number;
    is_color: boolean;
    is_description: boolean;
    is_image: boolean;
    is_rating: boolean;
    label: string;
    slug: string;
    universe: string;
}>;
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response500IO = t.unknown;
export type Response500Type = unknown;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiWebsiteCmsGetCustomSelectionsTemplateRequest"
 */
export const openapi_website_cms_getCustomSelectionsTemplate = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/website-cms/${params.universe}/custom-selections-template${query}`;
    
    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiWebsiteCmsGetCustomSelectionsTemplateParamsType = ParamsType;

export type OpenapiWebsiteCmsGetCustomSelectionsTemplateResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiWebsiteCmsGetCustomSelectionsTemplateResponse200Type = Response200Type;

export const openapiWebsiteCmsGetCustomSelectionsTemplateRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiWebsiteCmsGetCustomSelectionsTemplateResponseType> => {
    const response = await openapi_website_cms_getCustomSelectionsTemplate(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiWebsiteCmsGetCustomSelectionsTemplateRequest - unhandled response ${response.status}`);
};

